<template>
    <div class="notes-wrapper" v-bind:style="{ backgroundColor: bgColor }">
      <div class="title">{{ this.$t(`trip.expenses.documentDescriptions.${this.expenseType}`) }}
        <i :class="[iconStyle]" aria-hidden="true" notranslate="" style="font-size: 30px; padding-left: 10px; color: #343a40"></i>
      </div>
      <div>{{$t('trip.expenses.stats.totalQuantity')}}: <span class="bold-text">{{ totalQuantity }}</span></div>
      <div>{{$t('trip.expenses.stats.totalPrice')}}: <span class="bold-text">{{ totalPrice }}</span></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Stats',
    props: {
      stats: {
        type: Object,
        required: true
      }
    },
  computed: {
    totalPrice() {
      return this.stats.totalPrice || 0;
    },
    totalQuantity() {
      return this.stats.totalQuantity || 0;
    },
    expenseType() {
      return this.stats.expenseType || 'undefined';
    },
    iconStyle() {
      let expenseType = this.stats.expenseType;
      if (expenseType === 'exp-travel') {
        return 'maki maki-bus va-icon maki maki-bus';
      } else if (expenseType === 'exp-drivers') {
        return 'entypo entypo-user va-icon entypo entypo-user';
      } else if (expenseType === 'exp-hotel') {
        return 'fa va-icon fa fa-hotel top-padding';
      } else if (expenseType === 'exp-tickets') {
        return 'fa fa-ticket va-icon top-padding';
      } else if (expenseType === 'exp-plain') {
        return 'maki maki-airport va-icon maki maki-airport';
      } else if (expenseType === 'exp-insurance') {
        return 'fa fa-shield va-icon fa fa-shield top-padding';
      } else if (expenseType === 'exp-package') {
        return 'ion ion-logo-buffer va-icon top-padding';
      }
      return 'entypo entypo-dot-3 va-icon entypo entypo-dot-3';
    },
    bgColor() {
      let expenseType = this.stats.expenseType;
      let colorMap = {
        'exp-travel': '#4ae387A0',
        'exp-drivers': '#4ab2e3A0',
        'exp-hotel': '#ffff00A0',
        'exp-tickets': '#db76dfA0',
        'exp-plain': '#ff9900A0',
        'exp-insurance': '#006400A0',
        'exp-package': '#8a63d2A0',
        'exp-unknown': '#e34a4aA0'
      };
      return colorMap[expenseType];
    },
    }
  };
  </script>
  
  <style lang="scss">
  .notes-wrapper {
    border: 1px solid #000;
    border-radius: 10px;
    padding: 14px;
    padding-top: 10px;
    margin-top: 10px;
  }
  .title {
    font-weight: bold;
    font-size: large;
    color: #343a40;
  }
  .top-padding {
    padding-top: 7px;
    padding-bottom: 8px;
  }
  .bold-text {
    font-weight: bold;
  }
  </style>